__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/01c865f/packs/";